import { Chip, Grid, IconButton, Menu, MenuItem, Paper } from '@material-ui/core';
import {
  Brightness1 as Brightness1Icon,
  LocationOn as LocationOnIcon,
  Person as PersonIcon,
  DateRange,
  SchoolRounded as SchoolIcon,
  DescriptionRounded as DescriptionIcon,
  Work as WorkIcon,
  Loop as LoopIcon,
  MoreHoriz,
} from '@material-ui/icons';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { createFormation, deleteFormation, getCountCandidatByFormation } from '@webapps/business';
import { Button, ModalSideBar, useAuth, useMutation, useQuery, useToast } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Modal from 'components/Modal';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { FormattedDate } from 'react-intl';

import theme from '../theme';
import DetailsInformation from './DetailsFormation';
import EditFormation from './EditFormation';
import CardFormationSkeleton from './CardFormationSkeleton';

const {
  colors: { itemColor },
} = theme;

const CardFormation = ({
  address,
  contrat,
  item,
  name,
  refetchAllFormation,
  typeFormation,
  idTraining,
  isLoading = false
}) => {
  const {
    classes,
    css,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [viewOffre, setViewOffre] = useState(false);
  const [anchorVitrine, setAnchorVitrine] = useState(null);
  const openVitrineMenu = Boolean(anchorVitrine);
  const [editModal, setEditModal] = useState(false);
  const [stepModal, setStepModal] = useState(1);
  const { idUser } = useAuth();
  const { addToast } = useToast();

  const { data: countCandidat = '' } = useQuery(getCountCandidatByFormation, {
    key: 'countTraining' + idTraining,
    variables: { id: idTraining },
  });

  const handleOpenOffre = () => {
    setViewOffre(true);
  };
  const handleCloseOffre = () => {
    setViewOffre(false);
  };

  const date = new Date();

  const {
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteAnnonce,
  } = useMutation(deleteFormation);

  const handleDeleteAnnonce = async (id) => {
    await mutateDeleteAnnonce({ id });
    refetchAllFormation();
  };

  const {
    error,
    isSuccess: isSuccessDuplicate,
    mutateAsync: mutateDuplicateAnnonce,
  } = useMutation(createFormation);

  const handleDuplicateAnnonce = async (annonce) => {
    const data = {
      school: {
        id: idUser,
      },
      degreeLevel: {
        id: annonce.degreeLevel.id,
      },
      description: annonce.description,
      contractType: {
        id: annonce.contractType.id,
      },
      address: {
        label: annonce.address.label,
        cityCode: annonce.address.cityCode,
        city: annonce.address.city,
      },
      contractLength: annonce.contractLength,
      renewable: annonce.renewable,
      workArrangement: annonce.workArrangement,
      telework: annonce.telework,
      salary: annonce.salary,
      salaryMax: annonce.salaryMax,
      jobAdvantages: annonce.jobAdvantages,
      transport: annonce.transport,
      drivingLicence: annonce.drivingLicence,
      createdAt: new Date(),
      lastUpdateDate: '',
      publicationDate: new Date(),
      deadLine: annonce.deadLine,
      onlyVerfiedProfile: annonce.onlyVerfiedProfile,
      workedLangage: annonce.workedLangage
    }
    await mutateDuplicateAnnonce({
      data: {
        ...data,
      }
    });
  };

  useEffect(() => {
    if (error) {
      addToast({
        status: 'error',
        message: 'Erreur pour dupliquer une annonce',
      });
    }
    if (isSuccessDelete || isSuccessDuplicate) {
      addToast({
        status: 'success',
        message: 'Operation réussie',
      });
      refetchAllFormation();
      close();
    }
  }, [isSuccessDelete, isSuccessDuplicate]);

  if (isLoading) {
    return <CardFormationSkeleton />;
  }

  return (
    <Grid item xs={12} md={6} lg={3} style={{ padding: spacing(2.5, 2.5, 0, 0) }}>
      <Paper className={classes.paper}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className={global.title}>{name}</div>
          <IconButton
            onClick={(e) => setAnchorVitrine(e.currentTarget)}
            size='24px'
            aria-controls='candidature-menu'
            aria-haspopup="true"
            aria-expanded='true'
            style={{ margin: '0px 3px', alignSelf: 'baseline', borderRadius: '20px', border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF', width: '26px', display: 'flex', justifyContent: 'center', height: '26px', alignItems: 'center', cursor: 'pointer' }}>
            <MoreHoriz style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
          </IconButton>
          <Menu
            anchorEl={anchorVitrine}
            id="candidature-menu"
            open={openVitrineMenu}
            onClose={() => setAnchorVitrine(false)}
            onClick={() => setAnchorVitrine(false)}
            PaperProps={{ elevation: 2 }}
            transformOrigin={{ horizontal: 'left', vertical: -50 }}
            anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
          >
            <MenuItem disableRipple disableFocusRipple onClick={handleOpenOffre}>
              Voir l'offre
            </MenuItem>
            <MenuItem disableRipple disableFocusRipple onClick={() => setEditModal(true)}>
              Editer l'offre
            </MenuItem>
            {/* <MenuItem disableRipple disableFocusRipple onClick={() => handleDuplicateAnnonce(item)}>
              Dupliquer l'offre
            </MenuItem> */}
            <MenuItem disableRipple disableFocusRipple onClick={() => handleDeleteAnnonce(item.id)}>
              Supprimer l'offre
            </MenuItem>
          </Menu>
        </div>
        <div className={classes.items}>
          <div className={classes.cardItem}>
            <SchoolIcon className={global.infoIcon} />
            <div className={global.infoText}>{typeFormation.label}</div>
          </div>
          <div className={classes.cardItem}>
            <DescriptionIcon className={global.infoIcon} />
            <div className={global.infoText}>{contrat.label}</div>
          </div>
          <div className={classes.cardItem}>
            <LocationOnIcon className={global.infoIcon} />
            <div className={global.infoText}>{address.label}</div>
          </div>
          {/* <div className={classes.cardItem}>
            <VisibilityIcon className={global.infoIcon} />
            <div className={global.infoText}>{view} consultations</div>
          </div> */}
          <div className={classes.cardItem}>
            <PersonIcon className={global.infoIcon} />
            <div className={global.infoText}>{countCandidat} Candidats</div>
          </div>
          <div className={classes.cardItem}>
            <LoopIcon className={global.infoIcon} />
            <div className={global.infoText}>
              {item?.rythmAlternance && item?.rythmAlternance.length > 5 ?
                item?.rythmAlternance.includes("undefined") ? contrat.label === 'Formation continue' ? 'Cycle continu' : 'Cycle initial' :
                  item?.rythmAlternance.split('/').map((part, index) =>
                    index === 0
                      ? `${part.trim()} école`
                      : `${part.trim()} entreprise`
                  ).join(' / ')
                : contrat.label === 'Formation continue' ? 'Cycle continu' : 'Cycle initial'
              }
              {/* {item.rhythmAlternance ?
                item.rhythmAlternance.split('/').map((part, index) =>
                  index === 0
                    ? `${part.trim()} school`
                    : `${part.trim()} company`
                ).join(' / ')
                : typeFormation.label === 'Formation continue' ? 'Cycle continu' : 'Cycle initial'
              } */}
            </div>

          </div>
          {/* <div className={classes.cardItem}>
            <RestoreIcon className={global.infoIcon} />
            <div className={global.infoText}>Il y a {lastTimeView}</div>
          </div> */}
          <div className={classes.cardItem}>
            <VisibilityIcon className={global.infoIcon} />
            <div className={global.infoText}>{item?.views} Vues</div>
          </div>
          <div className={classes.cardItem}>
            <DateRange className={global.infoIcon} />
            <div className={global.infoText}>
              Candidature du{' '}
              <FormattedDate
                day="numeric"
                month="numeric"
                value={item.applicationStartDate}
                year="numeric"
              />
              {' '}au{' '}
              <FormattedDate
                day="numeric"
                month="numeric"
                value={item.applicationClosingDate}
                year="numeric"
              />
            </div>
          </div>
          <div className={classes.cardItem}>
            {new Date(item?.applicationStartDate?.split('T')[0]) <= date &&
              new Date(item?.applicationClosingDate?.split('T')[0]) >= date ?
              <Chip
                classes={{ colorPrimary: css({ background: '#DBFAD8', color: '#008000', borderRadius: '10.0000px' }) }}
                className={classes.chip}
                color="primary"
                label="Candidatures ouvertes"
                size="small"
              />
              :
              <Chip classes={{ colorPrimary: css({ background: '#FBD3D5', color: '#F50057', borderRadius: '10.0000px' }) }}
                className={classes.chip}
                color="primary"
                label="Candidatures fermées"
                size="small"
              />
            }
          </div>
        </div>
        <div className={classes.buttons}>
          {/* <Button variant="outlined">
            <FormattedMessage id="school.formationsCandidats.btnVoirCandidats" />
          </Button> */}
          <Button
            className={css({ marginTop: spacing(1.25), borderRadius: 10 })}
            onClick={handleOpenOffre}
            variant="outlined"
          >
            Voir la formation
          </Button>
        </div>
      </Paper>
      <ModalSideBar handleClose={handleCloseOffre} open={viewOffre} title={item?.label}>
        <DetailsInformation
          close={handleCloseOffre}
          info={item}
          refetchAllFormation={refetchAllFormation}
        />
      </ModalSideBar>
      <Modal
        nbStep={5}
        onCancel={() => setEditModal(false)}
        open={editModal}
        step={stepModal}
        // subTitle="Gérez votre annonce"
        title="Modifiez l'offre de formation"
      >
        <EditFormation
          formation={item}
          onChangeStepModal={setStepModal}
          onClose={() => setEditModal(false)}
          refetchFormation={refetchAllFormation}
        />
      </Modal>
    </Grid >
  );
};

const styles = ({ spacing }) => ({
  paper: {
    padding: spacing(2.5),
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    boxShadow: 'none',
  },
  cardItem: {
    display: 'flex',
    marginTop: spacing(0.5),
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
  },
  items: {
    marginTop: spacing(1),
  },
  chip: {
    marginTop: spacing(1),
    marginBottom: spacing(1),
    padding: spacing(2.5),
    borderRadius: '10.0px',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    '@media only screen and (max-width:768px)': { padding: spacing(2) },
  }
});

CardFormation.propTypes = {
  address: PropTypes.string,
  contrat: PropTypes.string,
  name: PropTypes.string,
  typeFormation: PropTypes.string,
  item: PropTypes.object,
  refetchAllFormation: PropTypes.func,
  idTraining: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool,
};

export default CardFormation;
